<template>
<div class="user-details">


	<confirm v-if="confirm.enabled" @cancel="confirm.enabled = false" @confirm="onConfirm">
		<span v-html="confirm.msg" slot="body"></span>
	</confirm>

	<h4 class="bg-blue-grey">SyncActions</h4>
	<div v-if="user.actions.length">

		<table class="split-50 table table-striped table-bordered">
			<thead>
				<tr>
					<th>Sync Action Description (for next sync)</th>
					<th>Sync Action Reason</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="action in user.actions">
					<td>{{action.description}}</td>
					<td>{{action.reason}}</td>
				</tr>
			</tbody>
		</table>
	</div>
	<div v-else class="bordered-row">
		<p>No pending sync actions</p>
	</div>
	<h4 class="bg-blue-grey">User Data</h4>
	<div class="container-fluid">
		<div class="col-md-5">
			<h4 class="bg-light-green">Schoox User</h4>
			<table class="user-details-table table table-striped table-bordered">
				<tbody>
					<tr>
						<th>Name:</th>
						<td>{{suName}}</td>
					</tr>
					<tr>
						<th>Id:</th>
						<td>{{su.id}}</td>
					</tr>
					<tr>
						<th>Email</th>
						<td>{{su.email}}</td>
					</tr>
				</tbody>
			</table>
			<h4 class="bg-light-green">Locations</h4>
			<table class="split-50 table table-striped table-bordered">
				<thead>
					<tr>
						<th>name</th>
						<th>jobs</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="loc in su.schooxLocations">
						<td>{{loc.name}}</td>
						<td v-html="getJobs(loc.jobs)"></td>
					</tr>
				</tbody>
			</table>

			<h4 class="bg-light-green">Academy Members</h4>
			<table class="split-50 table table-striped table-bordered">
				<thead>
					<tr>
						<th>id</th>
						<th>Hourly</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="member in su.acadMembers">
						<td>{{member.id}}</td>
						<td>{{member.hourlyWorker}}</td>
					</tr>
				</tbody>
			</table>

			<h4 class="bg-light-green">SSO Users</h4>
			<table class="table table-striped table-bordered">
				<thead>
					<tr>
						<th>User Id</th>
						<th>SSO Id</th>
						<th>External Id</th>
						<th>Added</th>
						<th>Last Modified</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="sso in su.ssoUsers">
						<td>{{sso.userId}}</td>
						<td>{{sso.ssoId}}</td>
						<td>{{sso.externalId}}</td>
						<td><span v-timestamp="sso.timeAdded"></span></td>
						<td><span v-timestamp="sso.modifiedAt"></span></td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="col-md-7">
			<template v-for="hsu, i in user.hsUsers">
				<h4 class="bg-blue-hs"><button v-on:click="confirmDelink(i)" class="pull-right">Delink User</button>HotSchedules User {{inc1(i)}}</h4>

				<table class="table table-striped table-bordered">
					<tbody>
						<tr>
							<th>Name:</th>
							<td>{{getUserName(hsu)}}</td>
						</tr>
						<tr>
							<th>Ids:</th>
							<td>{{displayList(hsu.ids)}}</td>
						</tr>
						<tr>
							<th>Email</th>
							<td>{{hsu.email}}</td>
						</tr>
						<tr>
							<th>HRID</th>
							<td>{{hsu.hrid}}</td>
						</tr>
						<tr>
							<th>Asc:</th>
							<td>{{hsu.asc}}</td>
						</tr>
						<tr>
							<th>Active</th>
							<td>{{hsu.active}}</td>
						</tr>
					</tbody>
				</table>
				<h4 class="bg-blue-hs">Locations</h4>
				<table v-if="hsu.locations.length" class="table table-striped table-bordered">
					<thead>
						<tr>
							<th>Id</th>
							<th>Location</th>
							<th>Academy Id</th>
							<th>Hierarchy Id</th>
							<th>extCompRef</th>
							<th>jobs</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="loc, li in hsu.locations">
							<td>{{loc.id}}</td>
							<td>{{loc.description}}</td>
							<td>{{loc.acadId}}</td>
							<td>{{loc.hierarchyid}}</td>
							<td>{{loc.extCompRef}}</td>
							<td v-html="getJobs(loc.jobs)"></td>
						</tr>
					</tbody>
				</table>
				<div v-else class="bordered-row">
					<p>No Locations Listed</p>
				</div>

				<h4 class="bg-blue-hs">Employee Set</h4>
				<table v-if="hsu.employeeSet.set.length" class="table table-striped table-bordered table-compact">
					<thead>
						<tr>
							<th>Name</th>
							<th>Id</th>
							<th>Email</th>
							<th>HRID</th>
							<th>Location</th>
							<th>Active</th>
							<th>Hierarchy Id</th>
							<th>extCompRef</th>
							<th>Jobs</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="row in hsu.employeeSet.set">
							<td>{{getUserName(row.employee)}}</td>
							<td>{{row.employee.id}}</td>
							<td>{{row.employee.email}}</td>
							<td>{{row.employee.hrid}}</td>
							<td>{{row.location.description}}</td>
							<td>{{row.employee.active}}</td>
							<td>{{row.location.hierarchyid}}</td>
							<td>{{row.location.extCompRef}}</td>
							<td v-html="getJobs(row.employee.jobs)"></td>
						</tr>
					</tbody>
				</table>
				<div v-else class="bordered-row">
					<p>No Employee Set Data</p>
				</div>
			</template>
		</div>
	</div>
</div>
</template>

<script>
import _ from 'underscore'

const blankUser = {
	email: '',
	schooxLocations: [],
	acadMembers: [],
	lastName: 'No Schoox User Record',
	firstName: '',
	id: '',
	ssoUsers: []
}

export default{
	name: 'UserDetails',
	props: {
		user: {
			type: Object
		},
		acadid: {}
	},
	data () {
		return {
			confirm: {
				enabled: false,
				action: null,
				msg: null
			}
		}
	},
	computed: {
		su () {
			return this.user.schooxUser || blankUser
		},
		suName () {
			return this.getUserName(this.su)
		},
		acadMembers () {
			return this.user.schooxUser.acadMembers
		}
	},
	methods: {
		getJobs (jobs) {
			return _.map(jobs, (j) => '<div>' + j.name + '</div>').join('')
		},
		getUserName (user = {}) {
			if (!user) { return 'NONE' }

			let uname = user.lastName

			if (!_.isEmpty(user.firstName)) {
				uname = uname + ', ' + user.firstName
			}
			return uname
		},
		formatActions () {

		},
		displayList (a) {
			if (!_.isArray(a)) { return '' }
			return a.join(', ')
		},
		inc1: (n) => n + 1,
		toConfirm (msg, action) {
			this.confirm.action = action
			this.confirm.msg = msg
			this.confirm.enabled = true
		},
		confirmDelink (n) {
			let user = this.user.hsUsers[n]
			let schooxid = this.su.id
			this.toConfirm('Confirm de-link. This action will not take effect until the next sync.', () => {
				this.$store.dispatch('delink', {
					acadid: this.acadid,
					user: {
						hsids: user.ids,
						schooxid: schooxid
					}
				})
			})
		},
		onConfirm () {
			if (this.confirm.action) {
				this.confirm.action()
			}
			this.confirm.enabled = false
		}
	}
}

</script>
<style>
.user-details .col-md-6, .user-details .col-md-5, .user-details .col-md-7{
	padding: 0
}
.user-details .container-fluid{
	padding-left: 0;
	padding-right: 0;
}
.user-details h4{
	padding:  10px 10px;
	margin:0;
	color: #FFFFFF;
}
.user-details h4 button{
	color: rgb(51, 51, 51);
	font-size: 14px;
	line-height: 20px;
	margin-top: -4px;
}
.user-details .table{
	margin-bottom: 0;
}
.bordered-row{
	border: 1px solid #ddd;
}
.user-details p{
	padding: 8px;
	margin: 0;
}
.split-50 td {
	width: 50%;
}
.user-details-table td:first-child{
	width: 25%;
}
.table-compact td, .table-compact th{
	font-size: 12px;
}
</style>


// WEBPACK FOOTER //
// UserDetails.vue?6bac69a4